import I18n from "i18n-js";
import ImportTemplateGenerator from "../../common/utils/ImportTemplateGenerator";
import { processTsvColumns } from "../../common/utils/fileUtils";
import { extractLastParenthesisContent } from "../../common/utils/formatUtils";

class InstallationUtils {
  static renderLabel(installation) {
    return `${installation.mark || ''} (${installation.designation})`.trim();
  }

  static downloadImportTemplate(
    fluids = [],
    oils = [],
    coolants = [],
    compressorTypes = [],
    compressorClassifications = [],
    compressorBrands = []
  ) {
    const generator = new ImportTemplateGenerator("import_installations", {
      headers: [
        I18n.t("pages.installations.import.template.client_number"),
        I18n.t("pages.installations.import.template.site_number"),
        I18n.t("pages.installations.import.template.installation_number"),
        I18n.t("pages.installations.import.template.fluid"),
        I18n.t("pages.installations.import.template.oil"),
        I18n.t("pages.installations.import.template.coolant"),
        I18n.t("pages.installations.import.template.designation"),
        I18n.t("pages.installations.import.template.nominal_load"),
        I18n.t("pages.installations.import.template.current_load"),
        I18n.t("pages.installations.import.template.identifier"),
        I18n.t("pages.installations.import.template.mark"),
        I18n.t("pages.installations.import.template.commissioning_date"),
        I18n.t("pages.installations.import.template.last_control_date"),
        I18n.t("pages.installations.import.template.leak_detection_system"),
        I18n.t("pages.installations.import.template.compressor_mark"),
        I18n.t("pages.installations.import.template.compressor_barcode"),
        I18n.t("pages.installations.import.template.compressor_serial_number"),
        I18n.t("pages.installations.import.template.compressor_type"),
        I18n.t("pages.installations.import.template.compressor_classification"),
        I18n.t("pages.installations.import.template.compressor_brand"),
      ],
      rows: [
        [
          "135653544",
          "23534",
          "23",
          fluids[0] ?? null,
          oils[0] ?? null,
          coolants[0] ?? null,
          "Station Froid - Nord",
          23,
          14,
          "8480002195202",
          "rep23",
          "24/12/2022",
          "12/02/2023",
          0
        ],
      ],
      constraints: [
        {
          columnName: "D",
          type: "list",
          sheetName: I18n.t("pages.installations.import.template.fluids_list"),
          values: fluids,
          helpMessage: {
            title: I18n.t("pages.installations.import.template.fluid:help:title"),
            message: I18n.t("pages.installations.import.template.fluid:help:message")
          },
          errorMessage: {
            title: I18n.t("pages.installations.import.template.fluid:error:title"),
            message: I18n.t("pages.installations.import.template.fluid:error:message")
          }
        },
        {
          columnName: "E",
          type: "list",
          sheetName: I18n.t("pages.installations.import.template.oils_list"),
          values: oils,
          helpMessage: {
            title: I18n.t("pages.installations.import.template.oil:help:title"),
            message: I18n.t("pages.installations.import.template.oil:help:message")
          },
          errorMessage: {
            title: I18n.t("pages.installations.import.template.oil:error:title"),
            message: I18n.t("pages.installations.import.template.oil:error:message")
          }
        },
        {
          columnName: "F",
          type: "list",
          sheetName: I18n.t("pages.installations.import.template.coolants_list"),
          values: coolants,
          helpMessage: {
            title: I18n.t("pages.installations.import.template.coolant:help:title"),
            message: I18n.t("pages.installations.import.template.coolant:help:message")
          },
          errorMessage: {
            title: I18n.t("pages.installations.import.template.coolant:error:title"),
            message: I18n.t("pages.installations.import.template.coolant:error:message")
          }
        },
        {
          columnName: "N",
          type: "boolean",
          helpMessage: {
            title: I18n.t("pages.installations.import.template.leak_detection_system:help:title"),
            message: I18n.t("pages.installations.import.template.leak_detection_system:help:message")
          },
          errorMessage: {
            title: I18n.t("pages.installations.import.template.leak_detection_system:error:title"),
            message: I18n.t("pages.installations.import.template.leak_detection_system:error:message")
          }
        },
        {
          columnName: "R",
          type: "list",
          sheetName: I18n.t("pages.installations.import.template.compressor_types_list"),
          values: compressorTypes,
          helpMessage: {
            title: I18n.t("pages.installations.import.template.compressor_type:help:title"),
            message: I18n.t("pages.installations.import.template.compressor_type:help:message")
          },
          errorMessage: {
            title: I18n.t("pages.installations.import.template.compressor_type:error:title"),
            message: I18n.t("pages.installations.import.template.compressor_type:error:message")
          }
        },
        {
          columnName: "S",
          type: "list",
          sheetName: I18n.t("pages.installations.import.template.compressor_classifications_list"),
          values: compressorClassifications,
          helpMessage: {
            title: I18n.t("pages.installations.import.template.compressor_classification:help:title"),
            message: I18n.t("pages.installations.import.template.compressor_classification:help:message")
          },
          errorMessage: {
            title: I18n.t("pages.installations.import.template.compressor_classification:error:title"),
            message: I18n.t("pages.installations.import.template.compressor_classification:error:message")
          }
        },
        {
          columnName: "T",
          type: "list",
          sheetName: I18n.t("pages.installations.import.template.compressor_brands_list"),
          values: compressorBrands,
          helpMessage: {
            title: I18n.t("pages.installations.import.template.compressor_brand:help:title"),
            message: I18n.t("pages.installations.import.template.compressor_brand:help:message")
          },
          errorMessage: {
            title: I18n.t("pages.installations.import.template.compressor_brand:error:title"),
            message: I18n.t("pages.installations.import.template.compressor_brand:error:message")
          }
        }
      ]
    });
    
    generator.downloadTemplate();
  }

  static processImportFileContent(tsvContent) {
    const columnsToProcess = [
      I18n.t("pages.installations.import.template.fluid"),
      I18n.t("pages.installations.import.template.oil"),
      I18n.t("pages.installations.import.template.coolant"),
      I18n.t("pages.installations.import.template.compressor_type"),
      I18n.t("pages.installations.import.template.compressor_classification"),
      I18n.t("pages.installations.import.template.compressor_brand"),
    ];

    return processTsvColumns(tsvContent, columnsToProcess, extractLastParenthesisContent);
  }

  static downloadCompressorsImportTemplate(types = [], classifications = [], brands = []) {
    const generator = new ImportTemplateGenerator("import_compressors", {
      headers: [
        I18n.t("pages.installations.import_compressors.template.client_number"),
        I18n.t("pages.installations.import_compressors.template.site_number"),
        I18n.t("pages.installations.import_compressors.template.installation_number"),
        I18n.t("pages.installations.import_compressors.template.mark"),
        I18n.t("pages.installations.import_compressors.template.barcode"),
        I18n.t("pages.installations.import_compressors.template.serial_number"),
        I18n.t("pages.installations.import_compressors.template.type"),
        I18n.t("pages.installations.import_compressors.template.classification"),
        I18n.t("pages.installations.import_compressors.template.brand"),
      ],
      rows: [
        [
          "135653544",
          "23534",
          "23",
          "rep23",
          "8480002195202",
          23,
          types[0] ?? "",
          classifications[0] ?? "",
          brands[0] ?? ""
        ],
      ],
      constraints: [
        {
          columnName: "G",
          type: "list",
          sheetName: I18n.t("pages.installations.import_compressors.template.types_list"),
          values: types,
          helpMessage: {
            title: I18n.t("pages.installations.import_compressors.template.type:help:title"),
            message: I18n.t("pages.installations.import_compressors.template.type:help:message")
          },
          errorMessage: {
            title: I18n.t("pages.installations.import_compressors.template.type:error:title"),
            message: I18n.t("pages.installations.import_compressors.template.type:error:message")
          }
        },
        {
          columnName: "H",
          type: "list",
          sheetName: I18n.t("pages.installations.import_compressors.template.classifications_list"),
          values: classifications,
          helpMessage: {
            title: I18n.t("pages.installations.import_compressors.template.classification:help:title"),
            message: I18n.t("pages.installations.import_compressors.template.classification:help:message")
          },
          errorMessage: {
            title: I18n.t("pages.installations.import_compressors.template.classification:error:title"),
            message: I18n.t("pages.installations.import_compressors.template.classification:error:message")
          }
        },
        {
          columnName: "I",
          type: "list",
          sheetName: I18n.t("pages.installations.import_compressors.template.brands_list"),
          values: brands,
          helpMessage: {
            title: I18n.t("pages.installations.import_compressors.template.brand:help:title"),
            message: I18n.t("pages.installations.import_compressors.template.brand:help:message")
          },
          errorMessage: {
            title: I18n.t("pages.installations.import_compressors.template.brand:error:title"),
            message: I18n.t("pages.installations.import_compressors.template.brand:error:message")
          }
        }
      ]
    });
    
    generator.downloadTemplate();
  }

  static processImportCompressorsFileContent(tsvContent) {
    const columnsToProcess = [
      I18n.t("pages.installations.import_compressors.template.type"),
      I18n.t("pages.installations.import_compressors.template.classification"),
      I18n.t("pages.installations.import_compressors.template.brand"),
    ];

    return processTsvColumns(tsvContent, columnsToProcess, extractLastParenthesisContent);
  }
}

export default InstallationUtils;
